import axios from '../index';

export const requestOrganizations = () => axios.get('/fhir/CareTeam');

export const requestOrganizationsAddOrganization = ({ siteId, data }) =>
  axios.put(`/fhir/Organization/${siteId}-organization`, data);

export const requestOrganizationsAddCareteam = ({ siteId, data }) =>
  axios.put(`/fhir/CareTeam/${siteId}-careteam`, data);
